import TextColor20 from '@carbon/icons-react/es/text--color/20';
import { Dropdown } from 'antd';
import throttle from 'lodash.throttle';
import React, { FC, useMemo, useCallback } from 'react';
import { GithubPicker } from 'react-color';
import { useDocuments } from 'components/organisms/document/document-store';
import { ozoneColorsArr } from 'config/ozone-colors';
import { ToolButtonWrapper } from '../tool-button-wrapper';

export const TextColor: FC<{ editor?: any }> = ({ editor: _editor }) => {
  const [state] = useDocuments();

  const editor = _editor ?? state.editor;
  const executes = (color: string) => {
    editor?.execute('fontColor', {
      value: color,
    });
    editor?.editing.view.focus();
  };

  // To improve performance a little bit
  const getColorFromAttr = useCallback(() => {
    const model = editor?.model;
    const selection = model?.document.selection;
    const fontColorAttr = selection?.getAttribute('fontColor');

    return fontColorAttr;
  }, [editor?.model]);

  const debouncedGetColorFromAttr = useMemo(
    () => throttle(getColorFromAttr, 300),
    [getColorFromAttr],
  );

  const textColor = debouncedGetColorFromAttr();

  const onChangeComplete = (newColor) => {
    const color = newColor.hex;

    executes(color);
  };

  const PickerMenu = () => (
    <div className="rl-text-color-picker-wrapper">
      <GithubPicker
        triangle="hide"
        onChangeComplete={onChangeComplete}
        colors={ozoneColorsArr}
      />
    </div>
  );

  return (
    <Dropdown overlay={PickerMenu} trigger={['hover']} placement="bottomRight">
      <div>
        <ToolButtonWrapper>
          <TextColor20 color={textColor} />
        </ToolButtonWrapper>
      </div>
    </Dropdown>
  );
};
